import {
    CHANGE_THEME_CONFIG
} from 'config/redux/actionTypes';

export const changeThemeConfig = (parameters) => ({
    type: CHANGE_THEME_CONFIG,
    payload: parameters
});
